import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("admin/logs/all", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
